import instanceAPI from 'services/apis/axiosconfig';

export const getExclusivityBanner = (bannerId) => {
  const request = instanceAPI.get(`/public/get-banner/${bannerId}`);
  return request.then((res) => ({
    ...res,
    data: {
      results: res.data,
    },
  }));
};
